import { loginAuthActionTypes } from './loginAuthActionTypes';

const { AUTHTOKEN } = loginAuthActionTypes;

const intialState = {
	token: '',
};

export const loginAuthReducers = (state = intialState, { type, payload }) => {
	switch (type) {
		case AUTHTOKEN:
			return { ...state, token: payload };
		default:
			return state;
	}
};
